export interface SelectionPanelOption {
  ID: string;
  name: string;
  image?: string;
  thumbnail?: string;
  description?: string;
  isSelected?: boolean;
}

export enum SelectType {
  Vertical = 'VERTICAL',
  Grid = 'GRID'
}

export enum SelectionPanelTransitionMode {
  FadeIn = 'fade-in',
  FadeOut = 'fade-out',
  TranslateIn = 'translate-in',
  TranslateOut = 'translate-out',
  None = 'none'
}
